import { combineReducers } from "redux";
import { appReducer } from "./app/reducer";
import { notificationReducer } from "./app/notification.reducer";
import { contactListReducer } from "./app/contactList.reducer";
import { emailReducer } from "./app/email.reducer";
import { voiceReducer } from "./app/voiceReducer";
import { chatReducer } from "./app/chatReducer";
import { customerPortalReducer } from "./app/CustomerPortal";

export const rootReducer = combineReducers({
  data: appReducer,
  notification: notificationReducer,
  contactListData: contactListReducer,
  email: emailReducer,
  voice: voiceReducer,
  chatReducer: chatReducer,
  customerPortal: customerPortalReducer,
});
